module.exports = "pegasus/assets/color-icon.png";